export default __webpack_public_path__ + "static/media/img_muslinTwoBunnyEarsBib_rg.875abf15.jpg";